import ProfileLogin from 'modules/auth/profile'
import React from 'react'

export default function Profile() {
    return <ProfileLogin />
}
